var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('PeriodCollege_govem_id',{attrs:{"period_college_id":_vm.period_college_id}}),_c('Alert_salary_gov')],1)}
var staticRenderFns = []

export { render, staticRenderFns }